/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/**
 * constants.js
 * @description Global constants and static configuration for the FuzzyVRM feature.
 * Contains page titles, field names, pagination defaults, and grid layout configuration.
 */

/**
 * Static code messages and field names for the FuzzyVRM feature
 * @type {Object}
 * @property {string} pageTitle - Template for the page title with placeholder for case number
 * @property {Object} fields - Field name mappings for data access
 * @property {string} fields.caseNumber - Case number field name
 * @property {string} fields.stage - Stage field name
 */
export const FUZZY_VRM_STATIC_CODE = {
  pageTitle: `Fuzzy VRM -  __caseNumber__`,
  fields: {
    caseNumber: 'caseNumber',
    stage: 'stage',
  },
}

/**
 * Default page size for grid pagination
 * @type {number}
 */
export const DEFAULT_PAGE_SIZE = 100

/**
 * Grid-wide configuration for layout and display
 * @type {Object}
 * @property {number} contractId - Default contract ID for API calls
 * @property {number} rowHeight - Height of each grid row in pixels
 * @property {Object} defaultColDef - Default column definition properties
 * @property {number} defaultColDef.flex - Flex value for responsive column sizing
 */
export const GRID_CONFIG = {
  contractId: 4,
  rowHeight: 50,
  defaultColDef: { flex: 1 },
}
